module.exports = "/ui/fonts/revicons.ttf";